module.exports = __webpack_public_path__ + "img/fig_dofa_5.fa71814c.svg";